import * as Yup from "yup";

export const EligibleSchema = Yup.object().shape({
  investorProfileEligibilityReason: Yup.string()
    .nullable()
    .trim()
    .required("This field is required"),
});
